import {ChartData} from "chart.js/auto";
import {SalesWrapper} from "../../../../utils/sales/sales-wrapper";
import {LinkedDtoRepository} from "../../../../../common/repositories/linked-dto-repository";
import {ColorMapService} from "../../../../../common/colors/color-map.service";
import {RevenueCalculationStrategy} from "../../../../../common/enums/strategies/revenue-calculation-strategy";

export class SankeyDatasetProcessor {
  static processSankeyChartDataset(baseOrderElementsWrapper: SalesWrapper, linkedDtoRepository: LinkedDtoRepository<any>, totalEmployeeCost: number, colorMapService: ColorMapService, revenueCalculationMethodOption: RevenueCalculationStrategy): ChartData<"sankey"> {
    let colorMap: { [id: string]: string } = {}

    let emptyDataset: ChartData<"sankey"> = {datasets: []};

    colorMap["totalInflow"] = "#007991";
    colorMap["taxes"] = "#E3655B";
    colorMap["employeeCost"] = "#B88B4A";
    colorMap["sourceDetailCost"] = "#31081F";
    colorMap["netRevenue"] = "#307351";
    colorMap["negativeRevenue"] = "#7d1c19";

    /*colorMap["totalInflow"] = "#007991";
    colorMap["taxes"] = "#7d1c19";
    colorMap["employeeCost"] = "#7d1c19";
    colorMap["sourceDetailCost"] = "#7d1c19";
    colorMap["netRevenue"] = "#307351";
    colorMap["negativeRevenue"] = "#7d1c19";*/
    colorMap["operatingCost"] = "#7d1c19";

    let labels: { [node: string]: string } = {
      totalInflow: "Umsatz",
      taxes: "Umsatzsteuer",
      employeeCost: "Personalkosten",
      sourceDetailCost: "Warenwert Einkauf",
      netRevenue: "Gewinn",

    };
    let data = []
    let negativeRevenue = []
    let counter = 0
    for (let location of baseOrderElementsWrapper.quantitativeBaseOrderCacheVO.dataCache.locationId!) {
      labels[location.id] = linkedDtoRepository.getName(location.id, "locationId");
      // push orginal value if revenueCalculationMethodOption is not set to "revenue"
      let value = revenueCalculationMethodOption === "revenue" ? location.value : baseOrderElementsWrapper.originalValueQuantitativeBaseOrderCacheVO.dataCache.locationId.find((element: {
        id: string,
        value: number
      }) => {
        return element.id === location.id
      })!.value;

      /*Remove just for debug purpose
      let isEven = counter %2 === 0;
      if(isEven){
        value = -value;
      }*/

      if (value >= 0) {
        data.push({from: location.id, to: "totalInflow", flow: value, colorSideFrom: "left", colorSideTo: "left"})
      } else {
        negativeRevenue.push({
          from: "negativeRevenue",
          to: location.id,
          flow: -value,
          colorSideFrom: "left",
          colorSideTo: "right"
        })
      }

      colorMap[location.id] = "#007991"//colorMapService.getColor(counter, baseOrderElementsWrapper.quantitativeBaseOrderCacheVO.dataCache.locationId!.length);
      counter++;
    }

    //let verluste = negativeRevenue.reduce((acc, cur) => acc + cur.flow, 0); -2 * verluste

    let taxes = baseOrderElementsWrapper.totalTaxes;
    let employeeCost = totalEmployeeCost;
    let sourceDetailCost = baseOrderElementsWrapper.totalSourceDetailsCost;
    // Todo add sourceDetailCost
    let operatingCost = employeeCost + sourceDetailCost;
    let netRevenue = baseOrderElementsWrapper.totalRevenue - operatingCost - taxes;


    colorMap["netRevenue"] = netRevenue > 0 ? "#307351" : "#7d1c19"//"#F5F5F5";
    if (netRevenue > 0) {
      data.push({from: "totalInflow", to: "netRevenue", flow: netRevenue, colorSideFrom: "left", colorSideTo: "right"});
    } else {
      data.push({from: "netRevenue", to: "totalInflow", flow: -netRevenue, colorSideFrom: "left", colorSideTo: "left"});
      labels["netRevenue"] = "Verlust"
    }

    if (operatingCost !== 0) {
      labels["operatingCost"] = "Betriebskosten"
      data.push({
        from: "totalInflow",
        to: "operatingCost",
        flow: operatingCost,
        colorSideFrom: "left",
        colorSideTo: "right"
      });
    }


    if (employeeCost > 0) {
      data.push({
        from: "operatingCost",
        to: "employeeCost",
        flow: employeeCost,
        colorSideFrom: "right",
        colorSideTo: "right"
      });
    } else {
      if (employeeCost < 0) {
        alert("Es wurden neagtive Personalkosten erkannt!")
        return emptyDataset;
      }
    }

    if (sourceDetailCost > 0) {
      data.push({
        from: "operatingCost",
        to: "sourceDetailCost",
        flow: sourceDetailCost,
        colorSideFrom: "left",
        colorSideTo: "right"
      });
    } else {
      if (sourceDetailCost < 0) {
        alert("Es wurde ein neagtiver Warenwert erkannt!")
        return emptyDataset;
      }
    }

    if (taxes > 0) {
      data.push({from: "totalInflow", to: "taxes", flow: taxes, colorSideFrom: "left", colorSideTo: "right"});
    } else {
      if (taxes < 0) {
        alert("Es wurden neagtive Steuern erkannt!")
        return emptyDataset;
      }
    }

    if (negativeRevenue.length > 0) {
      labels["negativeRevenue"] = "Zuzahlungen"
      let totalNegativeRevenue = negativeRevenue.reduce((acc, cur) => acc + cur.flow, 0);
      data.push({
        from: "totalInflow",
        to: "negativeRevenue",
        flow: totalNegativeRevenue,
        colorSideFrom: "left",
        colorSideTo: "right"
      });
      for (let negativeRevenueElement of negativeRevenue) {
        data.push(negativeRevenueElement);
      }
    }


    let chartData: ChartData<"sankey"> = {
      datasets: [
        {
          labels: labels,
          data: data,
          // @ts-ignore
          colorFrom: (c) => SankeyDatasetProcessor.getColorFromSankeyMapFrom(c.dataset.data[c.dataIndex], colorMap),
          // @ts-ignore
          colorTo: (c) => SankeyDatasetProcessor.getColorFromSankeyMapTo(c.dataset.data[c.dataIndex], colorMap),
          colorMode: "to",
          size: "max"
        }
      ]
    };
    return chartData
  }

  static getColorFromSankeyMap(key: { to: string, from: string, colorSide: string }, colorMap: {
    [id: string]: string
  }): string {
    if (key.colorSide === "left") {
      return colorMap[key.from] ?? "grey";
    }

    return colorMap[key.to] ?? "grey";

  }

  static getColorFromSankeyMapFrom(key: { to: string, from: string, colorSideFrom: string }, colorMap: {
    [id: string]: string
  }): string {
    if (key.colorSideFrom === "left") {
      return colorMap[key.from] ?? "grey";
    }

    return colorMap[key.to] ?? "grey";

  }

  static getColorFromSankeyMapTo(key: { to: string, from: string, colorSideTo: string }, colorMap: {
    [id: string]: string
  }): string {
    if (key.colorSideTo === "left") {
      return colorMap[key.from] ?? "grey";
    }
    return colorMap[key.to] ?? "grey";

  }
}
